module.exports = __webpack_public_path__ + "static/media/ANAGH R.3728381c.jpg";